import GestionnaireDeCarte from "@/script/TransCAM/GestionnaireDeCarte";
import { situationChoisie } from '@/script/champsCPS';

export default {
    namespaced: true,

    state: () => ({
        carteCPS: null,
        carteVitale: null,
        erreurChargement: false,
        erreurCodeCPS: false,
        nbTentativeDuCodeCPS: 3,
        connexionReussieAvecCarteCPS: null,
        messageNombreMaximumTentativeCodeCPSAtteint: "Vous avez atteint nombre maximum de tentative maxum",
        nbTentativeMaximumCodeCPSAtteint: false,
        challengeSigne: null,
        situationIndex: 1,
    }),

    mutations: {
        setCarteCPS(state, carte) {
            console.log("Dans Cartes.mutations.setCarteCPS", carte);
            state.carteCPS = carte;
        },
        setCarteVitale(state, carte) {
            state.carteVitale = carte;
        },
        setErreurChargement(state, erreur) {
            state.erreurChargement = erreur;
        },
        setErreurCodeCPS(state, bool) {
            state.erreurCodeCPS = bool;
        },
        setNbTentativeDuCodeCPS(state, nb) {
            state.nbTentativeDuCodeCPS = nb;
        },
        decrementerNbTentativeDuCodeCPS(state) {
            if (state.nbTentativeDuCodeCPS > 0)
                state.nbTentativeDuCodeCPS--;
            else
                state.nbTentativeMaximumCodeCPSAtteint = true;
        },
        resetNbTentativeDuCodeCPS(state) {
            state.nbTentativeDuCodeCPS = 3;
        },
        setConnexionReussieAvecCarteCPS(state, valeurConnexion) {
            state.connexionReussieAvecCarteCPS = valeurConnexion;
        },
        setChallengeSigne(state, val) {
            state.challengeSigne = val;
        },
        setSituationIndex(state, index) {
            state.situationIndex = Number(index) >= 1 ? Number(index) : 1;
        },
    },

    actions: {
        async chargerCarteCPS({ commit }) {
            try {
                const response = await GestionnaireDeCarte.getCarteCPS();
                commit("setCarteCPS", response);
                commit("setErreurChargement", false);
                commit("setErreurCodeCPS", false);
                commit("resetNbTentativeDuCodeCPS");
            } catch (err) {
                console.error("Erreur lors du chargement de la carte CPS :", err);
                commit("setErreurChargement", true);
                commit("setErreurCodeCPS", true);
                commit("decrementerNbTentativeDuCodeCPS");
            }
        },

        async chargerCarteVitale({ commit }, obj) {
            try {
                const response = await GestionnaireDeCarte.getCarteVitale(obj);
                commit("setCarteVitale", response);
                commit("setErreurChargement", false);
            } catch (err) {
                console.error("Erreur lors du chargement de la carte Vitale :", err);
                commit("setErreurChargement", true);
            }
        },

        // carte = tableau de blocs ; situation = rang 1-based (defaut 1).
        // Retro-compatible : un appel dispatch('Cartes/setCarteCPS', carte) (carte brute)
        // est traite comme { carte, situation: 1 }.
        async setCarteCPS({ commit }, payload) {
            const carte = payload && payload.carte !== undefined ? payload.carte : payload;
            const situation = payload && payload.situation ? payload.situation : 1;
            try {
                await GestionnaireDeCarte.setCarteCPS(carte, situation);
                commit("setCarteCPS", carte);
                commit("setSituationIndex", situation);
            } catch (err) {
                console.error("Erreur lors de l'envoi de la carte CPS :", err);
            }
        },

        async setCarteVitale({ commit }, carte) {
            try {
                await GestionnaireDeCarte.setCarteVitale(carte);
                commit("setCarteVitale", carte);
            } catch (err) {
                console.error("Erreur lors de l’envoi de la carte Vitale :", err);
            }
        }
    },

    getters: {
        getCarteCPS: (state) => state.carteCPS,
        getCarteVitale: (state) => state.carteVitale,
        getErreurChargement: (state) => state.erreurChargement,
        getErreurCodeCPS: (state) => state.erreurCodeCPS,
        getNbTentativeDuCodeCPS: (state) => state.nbTentativeDuCodeCPS,
        getConnexionReussieAvecCarteCPS: (state) => state.connexionReussieAvecCarteCPS,
        getMessageNombreMaximumTentativeCodeCPSAtteint: state => state.messageNombreMaximumTentativeCodeCPSAtteint,
        getNbTentativeMaximumCodeCPSAtteint: state => state.nbTentativeMaximumCodeCPSAtteint,
        getChallengeSigne: (state) => state.challengeSigne,
        getSituationIndex: (state) => state.situationIndex,
        getSituationChoisie: (state) => situationChoisie(state.carteCPS, state.situationIndex),

    }
};
